import { Spinner, Table } from "react-bootstrap"
import { GeneratedData, TypeData } from "../api/generate/store"
import React from "react"

const WordReplace = [
    "ID", "Id",
    "PDI", "Pdi",
    "No", "Number"
]

type DataTableProps = {
    generated: TypeData[]
    loading?: boolean
}

function getColumns(generated:TypeData[]) : string[] {
    const columns = []
    let key :keyof TypeData
    for (key in generated[0]) {
        columns.push(key)
    } 
    return columns
}

function transformColumnName(str:string) : string {
    let running =""
    for (let index = 0; index < WordReplace.length; index+=2) {
        str = str.replace( WordReplace[index], WordReplace[index+1] );       
    }

    for (let index = 0; index < str.length; index++) {
        if (str[index].match(/[A-Z]/)) {
            running += " " + str[index]
        } else {
            running += str[index]
        }
    }
    return running
}

const DataTable : React.FC<DataTableProps> = ({loading=false, generated = []}) => {
    if (loading) {
        return <Spinner />
    }

    if (!generated || generated.length === 0) {
        return <div className="table"><p className="text-muted m-3">No records to display.</p></div>
    }

    const columns = getColumns(generated)
    return <div className="table">
        <Table size="lg" striped borderless  hover>
            <thead>
                <tr>
                    {columns.map( (item,index) => <th key={index+"head"}>{transformColumnName(item)}</th>)}
                </tr>
            </thead>
            <tbody >
                { generated.map( (item, i) => (
                <tr key={i + "dh"}>
                    {columns.map( (c, index) => <td key={index + "data"}>{item[c]}</td>)}
                </tr>))
                }
            </tbody>
        </Table>
    </div>
}

export default DataTable
